import React from 'react';
import { FormattedMessage } from 'react-intl';

export enum FormItemState {
    NORMAL = "",
    OK = "is-valid",
    ERROR = "is-invalid",
}


export default function FormBase(props: {
    titleId?: string,
    id?: string,
    children: JSX.Element | string | JSX.Element[],
    feedBackId?: string
}) {
    return (
        <>
            <div className="form-group">
                <label htmlFor={props.id}><FormattedMessage id={props.titleId ? props.titleId : "empty"} defaultMessage={props.titleId} description={props.titleId} /></label>
                {props.children}
                <div className="invalid-feedback">
                    <FormattedMessage id={props.feedBackId ? props.feedBackId : "empty"} defaultMessage={props.feedBackId} description={props.feedBackId} />
                </div>
            </div>

        </>
    )
}